// extracted by mini-css-extract-plugin
export var scrollArea = "_ox-0";